import { render, staticRenderFns } from "./DiagramStatusLabel.vue?vue&type=template&id=4206cdb2"
import script from "./DiagramStatusLabel.vue?vue&type=script&lang=js"
export * from "./DiagramStatusLabel.vue?vue&type=script&lang=js"
import style0 from "./DiagramStatusLabel.vue?vue&type=style&index=0&id=4206cdb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports